import {searchSchool} from "../SchoolSetup/Services";

// The school search endpoint is paginated ({ totalItems, schoolList }). The
// Business Report needs every client at once to plot them on the map, so we
// walk the pages until we have them all (with a hard safety cap).
export async function fetchAllSchools() {
    const size = 200;
    const maxPages = 100;
    let page = 1;
    let all = [];
    let total = Infinity;

    while (page <= maxPages) {
        const response = await searchSchool({name: ""}, page, size);
        if (response.status !== 200) break;

        const {totalItems, schoolList} = response.data || {};
        if (typeof totalItems === "number") total = totalItems;
        if (!schoolList || schoolList.length === 0) break;

        all = all.concat(schoolList);
        if (all.length >= total || schoolList.length < size) break;
        page += 1;
    }

    return all;
}

// Loads the simplified Nepal district boundaries served from /public.
export async function fetchNepalDistricts() {
    const base = process.env.PUBLIC_URL || "";
    const response = await fetch(`${base}/geo/nepal-districts.geojson`);
    if (!response.ok) {
        throw new Error(`Failed to load district map (${response.status})`);
    }
    return response.json();
}
